<template>
  <div id="reportsWrapper">
    <div class="columns">
      <div class="column is-half">
        <div v-for="report in reports" :key="report.id" class="box">
          <article class="media">
            <div class="media-left">
              <i class="fas fa-file-alt fa-3x"></i>
            </div>

            <div class="media-content">
              <nav class="level is-mobile is-pulled-right">
                <div class="level-left">
                  <options-buttons @edit="edit(report.id)" @delete="remove(report.id)"></options-buttons>
                </div>
              </nav>

              <div class="content">
                <p>
                  <strong>{{ report.name }}</strong>
                </p>
              </div>
            </div>
          </article>
        </div>
      </div>

      <div class="column is-half">
        <create-button
          caption="Nieuw rapport"
          @click="create">
        </create-button>
      </div>
    </div>

    <edit-report :tableId="tableId"></edit-report>
  </div>
</template>

<script>
import { bus } from '@/main'
import { mapGetters } from 'vuex'
import EditReport from './EditReport'
import CreateButton from '@/components/modules/CreateButton'
import OptionsButtons from '@/components/modules/OptionsButtons'

export default {
  components: {
    EditReport,
    CreateButton,
    OptionsButtons
  },
  data () {
    return {
      table: null,
      modalState: false
    }
  },
  computed: {
    ...mapGetters({
      reports: 'reports/reports'
    })
  },
  created () {
    let self = this

    this.tableId = this.$route.params.tableId

    this.$store.dispatch('reports/loadAll', {
      tableId: this.tableId
    })

    bus.$on('reportCreated', function (report) {
      self.reports.push(report)
    })

    bus.$on('reportChanged', function (report) {
      self.reports.find(x => x.id === report.id).name = report.name
    })
  },
  methods: {
    create () {
      bus.$emit('toggleReportModal', {
        state: true
      })
    },
    edit (reportId) {
      this.$router.push({
        name: 'edit-report',
        params: {
          reportId: reportId
        }
      })
    },
    remove (reportId) {
      this.$store.dispatch('reports/remove', reportId)
    }
  }
}
</script>

<style scoped>
  .edit {
    margin-left: 5px;
  }
</style>
